export default __webpack_public_path__ + "static/media/promoMob.81c7b773.svg";